import BodyHeader from "../../../../components/common/CommonBodyHeader";
import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import * as Yup from "yup";
import { useFormik } from "formik";

import { useDispatch } from "react-redux";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";

import { categoryMasterSingleListAsync } from "../../../../redux/features/vehicle-category/singleListCategoryMasterSlice";
import { updateCategoryMasterAsync } from "../../../../redux/features/vehicle-category/updateCategoryMasterSlice";

const validationSchema = Yup.object().shape({
   category: Yup.string().required("Category is required"),
});

export default function VehicleCategoryEdit() {
   const { id } = useParams();
   const dispatch = useDispatch();
   const navigate = useNavigate();

   const initialValues = {
      category: "",
   };

   const handleUpdate = async (formData) => {
      formData.id = id;
      dispatch(backdropLoadingAction(true));
      dispatch(
         updateCategoryMasterAsync({
            data: formData,
            done: () => {
               formik.resetForm();
               dispatch(backdropLoadingAction(false));
               toast.success("Record added successfully.");
               navigate(-1);
            },
            err: () => {
               dispatch(backdropLoadingAction(false));
               //toast.error("Failed to add.");
            },
         }),
      );
   };

   useEffect(() => {
      if (id) {
         dispatch(backdropLoadingAction(true));
         dispatch(
            categoryMasterSingleListAsync({
               data: { id: id },
               done: (record) => {
                  formik.setFieldValue("category", record?.category_name);

                  dispatch(backdropLoadingAction(false));
               },
               err: () => {
                  dispatch(backdropLoadingAction(false));
               },
            }),
         );
      }
   }, [id]);

   const formik = useFormik({
      initialValues: initialValues,
      validationSchema: validationSchema,
      onSubmit: handleUpdate,
   });

   const { getFieldProps, handleSubmit, touched, errors } = formik;

   return (
      <div>
         <BodyHeader title="Vehicle Category Master" />
         <div className="p-3 shadow-lg">
            <div className="row">
               <div className="col-lg-12">
                  <div className="card card-primary">
                     <div className="card-header">
                        <h3 className="card-title">Vehicle Category Details</h3>
                     </div>

                     <div className="card-body">
                        <div className="row">
                           <div className="col-12 col-sm-12 col-md-6">
                              <CustomInput
                                 require
                                 label="Category"
                                 id="category"
                                 placeholder="Enter volume"
                                 {...getFieldProps("category")}
                                 errors={touched.category && errors.category}
                                 message={errors.category}
                              />
                           </div>
                           <div className="col-lg-12 mt-3 text-center">
                              <button
                                 className="btn btn-primary px-4 py-3"
                                 type="submit"
                                 onClick={handleSubmit}
                              >
                                 <h6 className="mb-0 text-uppercase">Submit</h6>
                              </button>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
}
